import utils from 'utils'
import submitSuccessPage from './view/submitSuccess.html'
import detailPage from '../../view/detail.html'
export default function submitSuccess($uibModal, httpRequest, logger, $stateParams, sweetalert, composeService, Upload) {
    return {
        restrict: 'E',
        scope: {
            changeState: '=',
            confirmSheetState: '<',
            selectItem: '<',
        },
        template: submitSuccessPage,
        controller: [
            '$scope',
            '$state',
            '$location',
            'initSortService',
            'composeService',
            'dictService',
            '$uibModal',
            ($scope, $state, $location, initSortService, composeService, dictService, $uibModal) => {
                $scope.ukeyList = JSON.parse(localStorage.getItem('user_info')).tax4UkeyList
                let confirmId = ''
                if( $stateParams.confirmId){
                    confirmId = $stateParams.confirmId
                }
                if($scope.selectItem && $scope.selectItem.confirmId){
                    confirmId = $scope.selectItem.confirmId
                }
                httpRequest.post_getRedConfirmBody({confirmId:confirmId}).then((res) => {
                    $scope.invoice = res.data.value
                })
                $scope.dictData = {}
                const types = ['red_confirm_work_status','red_confirm_status','red_confirm_open_status','red_confirm_red_reason','vat_usage_code','excise_usage_code','entry_status']
                httpRequest.get_dictByTypeArr(types).then((res) => {
                    $scope.dictData = res.data.value
                })
                // 返回列表
                $scope.returnList = () => {
                    $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
                }
                // 查看确认单详情
                $scope.confirmDetails = () => {
                    $uibModal
                        .open({
                            template: detailPage,
                            controller: 'redInkConfirmFormDetailCtrl',
                            backdrop: 'static',
                            openedClass: 'mod-modal mod-modal-hg-g',
                            resolve: {
                                items1() {
                                    return $scope.invoice
                                },
                            },
                        })
                        .result.then(
                        () => {},
                        () => {}
                    )
                }
                // 继续新增确认单
                $scope.continueToAdd = () => {
                    $scope.changeState('selectTicketTab')
                }
                //去开红票
                $scope.openRedTicket = () => {
                    $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.invoice', {
                        confirmIds:$scope.invoice.confirmId,
                        total:1,
                        type:'1',
                    })
                }
                //上传税局
                $scope.oneUpload = () => {
                    let ukeyList = $scope.ukeyList.filter(u => {
                        return u.ukeyId == $scope.invoice.ukeyId;
                    });
                    let mes = ''
                    if(ukeyList[0].manageType === '6' && $scope.invoice.confirmApplyFlag === 'Y' && $scope.invoice.confirmStatus === '01'){
                        mes = '本次红字确认单上传税局申请成功后，将直接生成红字发票，请确定是否继续提交?'
                    }
                    if(ukeyList[0].manageType === '6' && $scope.invoice.confirmApplyFlag === 'Y' && ($scope.invoice.confirmStatus === '02' || $scope.invoice.confirmStatus === '03')){
                        mes = '本次红字确认单上传税局申请成功后，需经对方确认，确认方确认后将直接生成红字发票，请确定是否继续提交?'
                    }
                    if(mes){
                        sweetalert.confirm('温馨提示', mes).then(() => {
                            realOneUpload()
                        })
                    }else {
                        realOneUpload()
                    }
                }
                function realOneUpload() {
                    httpRequest.post_uploadRedConfirm($scope.invoice.confirmId, $scope.invoice.ukeyId).then((res) => {
                        logger.logSuccess(res.data.value)
                        $state.go('outputManage.fullElectricInvoice.redInkConfirmForm.list')
                    })
                }
            },
        ],
        link(scope) {
        },
    }
}

submitSuccess.$inject = ['$uibModal', 'httpRequest', 'logger', '$stateParams', 'sweetalert', 'composeService', 'Upload']



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/directive/submitSuccess/submitSuccess.js